import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import useCart from '../../data/hooks/cart_hook';
import { RootState } from '../../data/reducers';
import { AppDispatch } from '../../data/storeConfig';
import { CartProductTile } from '../../shared/components/product_components/cart_product_tile';
import { NavigationShell } from '../../shared/navigation_shell/navigation_shell';
import { formatAmount, getImageUrl } from '../../utility/common';
import * as storeActions from '../../data/reducers/store.reducer';
import { socialIcons } from '../../assets/assets';

export const OrderPlacedPage = () => {
  const { storeSlug, orderId } = useParams<any>();
  const dispatch = useDispatch<AppDispatch>();
  const {
    cartItems,
    cartItemCount,
    cartSubTotalAmount,
    discount,
    cartTotalAmount,
    setCoupon,
    calculateTotal,
    clearCart,
  } = useCart();
  const { shopperAccountId } = useSelector((state: RootState) => state.authReducer);
  const { purchaseOrderData, storeInfo } = useSelector((state: RootState) => state.storeReducer);
  const { addressInfo } = useSelector((state: RootState) => state.cartReducer);
  useEffect(() => {
    calculateTotal();
  }, [cartItems]);

  useEffect(() => {
    clearCart();
    if (storeSlug && orderId && shopperAccountId) {
      dispatch(
        storeActions.fetchPurchaseOrderById({
          storeSlug: storeSlug,
          purchaseOrderId: orderId,
          shopperAccountId: shopperAccountId,
        }),
      );
    }
  }, [storeSlug, orderId, shopperAccountId]);

  return (
    <NavigationShell title={`Order placed`} isBackVisible={false}>
      <div className="">
        <div className="text-theDarkOne text-center mx-6 py-6 border-b">
          <h2 className="uppercase font-medium mb-1 text-2xl">Order placed!</h2>
          <h4 className="text-center text-theLighterDark">Contact merchant:</h4>
          <div className="flex flex-row justify-center mt-2">
            <a
              className="mx-2"
              href={`viber://add?number=${storeInfo?.ownerUsers ? storeInfo?.ownerUsers[0].phoneNumber : ''}`}
            >
              <img src={socialIcons.ViberLogo} className="w-10 flex" />
            </a>
            <a
              className="mx-2"
              href={`whatsapp://send?phone=${
                storeInfo?.ownerUsers ? storeInfo?.ownerUsers[0].phoneNumber : ''
              }`}
            >
              <img src={socialIcons.WhatsappLogo} className="w-10 flex" />
            </a>
            <a className="mx-2" href={`sms:${storeInfo?.ownerUsers ? storeInfo?.ownerUsers[0].phoneNumber : ''}`}>
              <img src={socialIcons.SmsLogo} className="w-10 flex" />
            </a>
            <a className="mx-2" href={`tel:${storeInfo?.ownerUsers ? storeInfo?.ownerUsers[0].phoneNumber : ''}`}>
              <img src={socialIcons.CallLogo} className="w-10 flex" />
            </a>
          </div>
        </div>
        <div className="text-theDarkOne text-left mx-6 py-6 border-b">
          <h3 className="uppercase font-medium mb-1">{purchaseOrderData.fulfilmentType == "DELIVERY" ? "Shipping to" : "Order details"}</h3>
          <div>
            {purchaseOrderData?.shopperAccount?.fullName}
            <div className="text-theLighterDark mb-1">{purchaseOrderData?.shippingAddress?.contactNumber ?? purchaseOrderData?.shopperAccount?.phoneNumber}</div>
            {purchaseOrderData?.fulfilmentType == 'DELIVERY' ? (
              <div className="font-medium">
                {purchaseOrderData?.shippingAddress?.addressLine1}{' '}
                {purchaseOrderData?.shippingAddress?.addressLine2 ??
                  `,${purchaseOrderData?.shippingAddress?.addressLine2},`}{' '}
                {purchaseOrderData?.shippingAddress?.landmark ?? `,${purchaseOrderData?.shippingAddress?.landmark}, `}{' '}
                {purchaseOrderData?.shippingAddress?.locality}
                {', '}
                {purchaseOrderData?.shippingAddress?.city}
                {/* {', '}
              {purchaseOrderData.shippingAddress?.}{' '} */}
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
        {/*Add Cart Product listing */}
        <div className="flex-row px-6 pb-4">
          {purchaseOrderData?.products?.map((product) => {
            return <CartProductTile key={product.storeProductId} product={product} isEditDisabled={true} />;
          })}
        </div>

        <div className="w-full border-t border-gray-300"></div>

        <div className="flex-row md:flex-row px-6 pb-4 divide-y">
          {/* Sub Total */}
          <div className="flex md:flex bg-white pb-4 md:pb-4 pt-4 md:pt-4">
            <div className="w-1/2 md:w-1/2 text-left md:text-left space-y-1 font-inter font-medium text-black">
              Sub Total
            </div>
            <div className="w-1/2 md:w-1/2 text-right md:text-right space-y-1 font-semibold text-black">
              {formatAmount(purchaseOrderData?.subTotal)}
            </div>
          </div>

          {/* Coupon */}
          {/* <div className="flex md:flex bg-white pb-4 md:pb-4 pt-4 md:pt-4">
            <div className="w-1/2 md:w-1/2 text-left md:text-left space-y-1 font-inter font-medium text-black">
              Coupon discount
            </div>
            <div className="w-1/2 md:w-1/2 text-right md:text-right space-y-1 font-semibold text-black">
              {formatAmount(purchaseOrderData?.couponDiscount)}
            </div>
          </div> */}

          {/* Discount */}
          <div className="flex md:flex bg-white pb-4 md:pb-4 pt-4 md:pt-4 ">
            <div className="w-1/2 md:w-1/2 text-left md:text-left space-y-1 font-inter font-medium text-black">
              Coupon Discount
            </div>
            <div className="w-1/2 md:w-1/2 text-right md:text-right space-y-1 font-semibold text-black flex flex-col gap-2 items-end">
              {formatAmount(purchaseOrderData?.couponDiscount)}
              <div className='px-2 py-1.5 border-dashed bg-primaryViolet bg-opacity-20 border border-primaryViolet w-max rounded-lg text-primaryViolet text-opacity-90'>{purchaseOrderData?.appliedCouponInfo?.couponCode}</div>
            </div>
          </div>

          {/* Total */}
          <div className="flex md:flex bg-white pt-4 md:pt-4">
            <div className="w-1/2 md:w-1/2 text-left md:text-left space-y-1 font-inter font-medium text-black">
              Total
            </div>
            <div className="w-1/2 md:w-1/2 text-right md:text-right space-y-1 font-semibold text-black">
              {formatAmount(purchaseOrderData?.total)}
            </div>
          </div>
        </div>

        <div className="w-full border-t border-gray-300"></div>

        <div className="p-6 sticky bottom-0 bg-white">
          <Link to={`/${storeSlug}`}>
            <button className="w-full md:w-full p-3 md:p-3 bg-primaryViolet text-white font-medium rounded-xl">
              Go to home
            </button>
          </Link>
        </div>
      </div>
    </NavigationShell>
  );
};
